import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import { animate, motion, useInView } from 'framer-motion';
import { usePortalMotion } from '../../../hooks/portal/usePortalMotion';
import { jsx as _jsx } from "react/jsx-runtime";
var EASE = [0.22, 1, 0.36, 1];
var offsetMap = {
  up: {
    y: 48
  },
  down: {
    y: -48
  },
  left: {
    x: 64
  },
  right: {
    x: -64
  },
  none: {}
};
export var RevealView = function RevealView(props) {
  var className = props.className,
      children = props.children,
      _props$delay = props.delay,
      delay = _props$delay === void 0 ? 0 : _props$delay,
      _props$duration = props.duration,
      duration = _props$duration === void 0 ? 0.75 : _props$duration,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'up' : _props$direction;

  var _usePortalMotion = usePortalMotion(),
      motionEnabled = _usePortalMotion.motionEnabled;

  if (!motionEnabled) return /*#__PURE__*/_jsx(Box, {
    className: className,
    children: children
  });
  return /*#__PURE__*/_jsx(motion.div, {
    className: className,
    initial: _objectSpread({
      opacity: 0
    }, offsetMap[direction]),
    whileInView: {
      opacity: 1,
      x: 0,
      y: 0
    },
    viewport: {
      once: true,
      amount: 0.2
    },
    transition: {
      duration: duration,
      delay: delay,
      ease: EASE
    },
    children: children
  });
};
export var StaggerView = function StaggerView(props) {
  var className = props.className,
      children = props.children,
      _props$stagger = props.stagger,
      stagger = _props$stagger === void 0 ? 0.12 : _props$stagger,
      _props$delay2 = props.delay,
      delay = _props$delay2 === void 0 ? 0.05 : _props$delay2;

  var _usePortalMotion2 = usePortalMotion(),
      motionEnabled = _usePortalMotion2.motionEnabled;

  if (!motionEnabled) return /*#__PURE__*/_jsx(Box, {
    className: className,
    children: children
  });
  return /*#__PURE__*/_jsx(motion.div, {
    className: className,
    initial: "hidden",
    whileInView: "visible",
    viewport: {
      once: true,
      amount: 0.15
    },
    variants: {
      visible: {
        transition: {
          staggerChildren: stagger,
          delayChildren: delay
        }
      }
    },
    children: children
  });
};
export var StaggerItemView = function StaggerItemView(props) {
  var className = props.className,
      children = props.children,
      _props$distance = props.distance,
      distance = _props$distance === void 0 ? 32 : _props$distance;

  var _usePortalMotion3 = usePortalMotion(),
      motionEnabled = _usePortalMotion3.motionEnabled;

  if (!motionEnabled) return /*#__PURE__*/_jsx(Box, {
    className: className,
    children: children
  });
  return /*#__PURE__*/_jsx(motion.div, {
    className: className,
    variants: {
      hidden: {
        opacity: 0,
        y: distance
      },
      visible: {
        opacity: 1,
        y: 0
      }
    },
    transition: {
      duration: 0.65,
      ease: EASE
    },
    children: children
  });
};
export var CountUpView = function CountUpView(props) {
  var value = props.value,
      _props$prefix = props.prefix,
      prefix = _props$prefix === void 0 ? '' : _props$prefix,
      _props$suffix = props.suffix,
      suffix = _props$suffix === void 0 ? '' : _props$suffix,
      _props$duration2 = props.duration,
      duration = _props$duration2 === void 0 ? 1.8 : _props$duration2,
      className = props.className;

  var _usePortalMotion4 = usePortalMotion(),
      motionEnabled = _usePortalMotion4.motionEnabled;

  var ref = useRef(null);
  var isInView = useInView(ref, {
    once: true,
    amount: 0.6
  });

  var _useState = useState(value),
      displayValue = _useState[0],
      setDisplayValue = _useState[1];
  /**
   * effects
   */


  useEffect(function () {
    if (!motionEnabled) {
      setDisplayValue(value);
      return;
    }

    if (!isInView) {
      setDisplayValue(0);
      return;
    }

    var controls = animate(0, value, {
      duration: duration,
      ease: 'easeOut',
      onUpdate: function onUpdate(latest) {
        return setDisplayValue(Math.round(latest));
      }
    });
    return function () {
      return controls.stop();
    };
  }, [isInView, motionEnabled, value, duration]);
  return /*#__PURE__*/_jsx(Box, {
    component: "span",
    ref: ref,
    className: className,
    children: "".concat(prefix).concat(displayValue).concat(suffix)
  });
};